import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { setShowMobileChat } from '../../../actions/chatLoginActions';
import { ChatBlackBG, CloseChatBlackBG } from '../../QPlayerSVGElement';

import './ChatToggle.scss';

const Container = styled.div`
	display: flex;
	justify-content: center;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 5px;
	pointer-events: all;
	height: 40px;
	width: 40px;
	align-items: center;
`;

const ChatToggle = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const showMobileChat = useSelector((state) => state.chatLoginReducer.showMobileChat);

	return (
		<Container
			tabIndex={-1}
			className="bottomControlbarChatTogle"
			role="button"
			aria-label={t(showMobileChat ? 'CHAT_WINDOW_CLOSE' : 'CHAT_WINDOW_OPEN')}
			onClick={() => dispatch(setShowMobileChat(!showMobileChat))}
		>
			{showMobileChat ? <CloseChatBlackBG /> : <ChatBlackBG />}
		</Container>
	);
};

export default ChatToggle;
